import { ArrowUpRight } from "lucide-react";
import { SERVICES } from "@/data/site";
import { useReveal } from "@/hooks/useReveal";
import { SectionHeading } from "@/components/site/SectionHeading";

const ServiceCard = ({ service, index }) => {
  const [ref, visible] = useReveal();
  const Icon = service.icon;
  return (
    <a
      ref={ref}
      href="#contact"
      data-testid={`service-card-${index}`}
      style={{ transitionDelay: `${(index % 3) * 90}ms` }}
      className={`reveal ${visible ? "is-visible" : ""} group relative overflow-hidden border border-zinc-800 bg-zinc-950 min-h-[300px] flex flex-col justify-end`}
    >
      <div className="absolute inset-0">
        <img
          src={service.image}
          alt={service.title}
          className="h-full w-full object-cover opacity-60 group-hover:opacity-45 group-hover:scale-105 transition-all duration-300"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black via-black/70 to-black/10" />
      </div>

      <div className="relative z-10 p-7">
        <span className="inline-flex h-11 w-11 items-center justify-center bg-red-600 mb-4">
          <Icon className="h-5 w-5 text-white" />
        </span>
        <h3 className="font-heading text-2xl md:text-3xl tracking-wide text-white flex items-center gap-2">
          {service.title}
          <ArrowUpRight className="h-5 w-5 text-red-500 opacity-0 -translate-x-1 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-150" />
        </h3>
        <p className="mt-2 text-sm text-zinc-400 leading-relaxed max-w-xs">
          {service.desc}
        </p>
      </div>
      <span className="absolute top-0 left-0 h-1 w-0 bg-red-600 group-hover:w-full transition-all duration-300" />
    </a>
  );
};

export const Services = () => {
  return (
    <section id="services" data-testid="services-section" className="relative bg-black py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <SectionHeading
          label="What We Do"
          title="Our Services"
          desc="One trusted crew for the whole home. No job too big or too small."
        />
        <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {SERVICES.map((s, i) => (
            <ServiceCard key={s.title} service={s} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
};
